<div [formGroup]="frm">
    <div class="ms-Dropdown dropdown" tabindex="0">
        <label [ngClass]="required ? 'is-required ms-Label' : 'ms-Label'" [for]="formControlName">{{label}}</label>
        <div *ngIf="!searchable">
            <i class="ms-Dropdown-caretDown ms-Icon ms-Icon--ChevronDown"></i>
            <select [formControlName]="formControlName" class="form-control" [class]="classField"></select>
        </div>
        <div *ngIf="searchable">
            <ng-select
			    [items]="searchableData"
			    [selectOnTab]="true"
			    [bindValue]="searchableBindValue"
			    [bindLabel]="searchableLabelForId"
			    [placeholder]="'Seleccione ' + label"
			    [formControlName]="formControlName">
		    </ng-select>
        </div>
    </div>
    <div style="color: brown;" *ngIf="ctrlInvalid" class="text-danger">
        {{label}} no cuenta con el formato correcto.
    </div>
</div>
